/* eslint-disable no-console */
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ErrorBoundary } from './pages/error-bundary';

// if (process.env.NODE_ENV === 'production') {
// 	console.log = () => {};
// 	console.error = () => {};
// 	console.debug = () => {};
// }

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<ErrorBoundary>
		<App />
	</ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
